import { MouseEvent } from 'react';

import CloseButton from 'src/components/buttons/close-button';

interface Props {
  closeToast?: () => void;
}

const ToastifyCloseButton = ({ closeToast }: Props) => {
  const handleClose = (e: MouseEvent) => {
    // prevent call of toast message click handler when close button is clicked
    e.stopPropagation();

    closeToast?.();
  };

  return (
    <CloseButton onClose={handleClose} classNames="Toastify__close-button" />
  );
};

export default ToastifyCloseButton;
